import React, {Component} from 'react';
import {render} from 'react-dom';
import Pbajax from 'c-up-pbajax';
import notification from 'c-notification';
import loading from 'c-up-loading';
import Cache from 'c-cache';
import IM, {Sessions, FriendList, getMsgType, FriendApply} from 'c-im';
import { ConversationListView, OfficeItemView, UserChatItemView, FriendApplyListView, FriendListView , ApplyConfirm, OfflineConfirm, ChatMsgListView } from './views/index';
import { ImageView, Gender, Grade } from '../component/user-ui';
import confirmPopup from '../lib/popup/confirm';
import sensitive from '../component/sensitive-words/index';
import lang from '../lang';

class App extends Component {

    static defaultProps = {
        navs: [
            {
                option: 'msg'
            },
            {
                option: 'friend'
            },
            {
                option: 'apply'
            }
        ],
        defaultSelected: 'msg'
    }
    
    constructor(props){
        super(props);

        this.state = {
            fullScreen: 0,
            friends: [], // 好友列表
            friendApplyList: [], // 好友请求列表
            conversations: [], // 会话列表
            selected: props.defaultSelected,
            activedChatUid: props.activedChatUid,
            activeFriend: { } , // 当前会话的好友
            activeSessionContent: [], // 当前会话的会话内容
            activeFriendValid: 0, // 与当前用户是否为相互关注的好友
            applyNotice: 0,
            sessionNotice: {},
            showApplyConfirm: 0,
            showOfflineConfirm: 0
        }
        let userToken = UP.Global.getUserToken();
        let sid = UP.Global.getUserId();
        let countryCode = UP.Global.getUser().countryCode; // 当前用户的国家码
        this.countryCode =  countryCode;

        this.pbajax = new Pbajax();
        this.friendList = new FriendList(userToken);
        this.session = new Sessions(userToken);
        // im
        let im = this.im = new IM({
            userToken,
            sid,
            termType: 3, 
        });
        // 好友申请
        this.friendApply = new FriendApply({
            im,
            uid: sid,
            userToken,
        });

        this.cache = new Cache({
            prefix: 'im/uplive/' + sid
        });

        let cacheSessionContent = this.cache.getCache('imdata') || {};

         $.map(cacheSessionContent, (sessionContent, uid)=>{
            for (let i = sessionContent.length; i--;) {
                let item = sessionContent[i];
            
                if (!item.isSelf) {
                    continue;
                }

                if (item.submiting == 1) {
                    item.submiting = -1;
                }
            }
        })

        this.cacheSessionContent = cacheSessionContent;
    }

    componentWillMount() {
        this.getFriendList();
        this.bindImMessage();
        this.getSessions();
        this.friendApply.init();
        this.updateApplyList();
        this.setState({
            sessionNotice: this.cache.getCache('noticedata') || {}
        });
    }

    componentDidMount() {
        // 监听好友请求
        // 1. 当前视窗为好友申请列表的话，更新列表
        // 2. 当前视窗为非好友申请列表话，添加红点数字类型
        $.channel.on('onNewFriendApply', (data)=>{
            this.handleNewFriendApply(data);
        });

        // 成为好友。A在手机操作；A在WEB需要重新渲染UI 
        $.channel.on('onFriendValid', (uid)=>{
            this.updateApplyList();
            this.addFriendById(uid);
        })

        // 取消好友
        $.channel.on('onFriendInvalid', (uid)=>{
            this.deleteFriendById(uid);
        })

        $.channel.on('talkTo', (userinfo)=>{
            this.talkToNewFriend(userinfo);
        })

        $(document.body).on('click', (e)=>{
            //监听路由改变
            let el = $(e.target);
            let fullScreen = 0;

            if ($('#J-IMChat').find(el).length > 0 || $('.J_PreviewPic').find(el).length > 0) {
                fullScreen = 1;
            }

            this.setState({
                fullScreen
            });
            //支付页面呼叫客服
           // setTimeout(this.getServer,500)


        });

        if( ('onhashchange' in window) && ((typeof document.documentMode==='undefined') || document.documentMode==8)) {
            window.onhashchange = this.gethashChange;
        } else {
            setInterval(function () {
                var ischanged = isHashChanged();
                if(ischanged) {
                    this.gethashChange;  // TODO，对应新的hash执行的操作函数
                }
            },150)

        }

        $.channel.on('showChat', () => {
            this.toggleChatFullScreen(1);
        });

    }
    
    gethashChange =()=> {
        window.scroll(0,0);
    }

    componentWillUnmount(){
        $.channel.off('onNewFriendApply');
        $.channel.off('onFriendValid');
        $.channel.off('onFriendInvalid');
        $.channel.off('talkTo');
        $.channel.off('showChat');
    }

    handleNewFriendApply(data) {
        let applyNotice = data.newCount;
        let friendApplyList = data.applyList;

        this.setState({
            friendApplyList
        });

        if (this.state.fullScreen == 1) {
            // 好友申请非actived，显示红点提示
            if (this.state.selected !== 'apply') {
                this.setState({
                    applyNotice
                });
            }
        } else {
            this.setState({
                applyNotice
            });
        }
    }

    getSessions() {
        this.session.getData().done((data)=>{
            let sessionNotice = this.state.sessionNotice;
            let conversations = [];

            data.conversations.forEach((item, index)=>{
                if (!sessionNotice[item.oid]) {
                    sessionNotice[item.oid] = 0;
                }
                if (item.type == 7) {
                    conversations[conversations.length] = item;
                }
            })

            this.cacheNoticeData(sessionNotice);

            this.setState({
                conversations,
                sessionNotice
            });
        });
    }

    cacheIMData() {
        this.cache.setCache('imdata', this.cacheSessionContent, + new Date() + 24 * 60 * 60 * 1000);
    }

    cacheNoticeData(data) {
        this.cache.setCache('noticedata', data, + new Date() + 24 * 60 * 60 * 1000);
    }

    getFriendList() {
        this.friendList.getData().done((data)=>{

            this.setState({
                friends: data.infos,
            });
        });
    }

    getFriendById(uid) {
        return this.friendList.getFriendById(uid);
    }

    bindImMessage() {
        let im = this.im;
        let closeCount = 0;

        im.on('arrivedServer', (msgid, msgVersion)=>{
            // 服务器端收到用户发送的请求
            let { activeFriend , activeSessionContent} = this.state;

            $.map(this.cacheSessionContent, (sessionContent, uid)=>{
                for (let i = sessionContent.length; i--;) {
                    let item = sessionContent[i];
                    
                    if (!item.isSelf) {
                        continue;
                    }

                    if (item.msgid == msgid) {
                        item.msgVersion = msgVersion;
                        item.submiting = 0;
                        break;
                    }
                }
            })

            this.cacheIMData();

            activeSessionContent = this.getSessionContent(activeFriend.oid);    
            
            this.setState({
                activeSessionContent
            });
        });

        im.on('forcedOffline', ()=>{
            this.forcedOffline();
        });

        // 断线重连
        im.on('close', function(cfg) {
            console.log('socket closed');
            
            if (im.forcedOffline == 1) {
                return;
            }
            // 异常状态导致连接断开，发起重连操作
            if (closeCount >= 5) {
                im.reinit();
                closeCount = 0;
                return;
            }
            setTimeout(function() {
                im.reconnect();
                closeCount++;
            }, 1500);
        });

        im.on('message', (data)=>{
            
            if (data.sId ==  10004 || data.sId == 10001) {
                return;
            }

            let { activeFriend, sessionNotice, fullScreen , activeSessionContent, selected} = this.state;

            let msgType = getMsgType(data);
            let friendInfo = this.getFriendById(data.sId);

            if (data.sId == 10005) {
                friendInfo = {
                    oid: 10005,
                    avatar: '//g.cdn.pengpengla.com/oauthgame/html5/20181102/b337ac6311d5b3d03d32838f4253354f.png',
                    username: '官方客服'
                }
            }

            if (msgType == 'friendText') {
                this.addSessionContent(data.sId, {
                    isSelf: 0,
                    oid: friendInfo.oid,
                    content: data.body.content,
                    avatar: friendInfo.avatar,
                    username: friendInfo.username,
                    msgVersion: data.msgVersion,
                    msgid: data.msgid,
                    msgType,
                });
            } else if (msgType == 'friendPic') {
                this.addSessionContent(data.sId, {
                    isSelf: 0,
                    oid: friendInfo.oid,
                    origUrl: data.body.origUrl,
                    avatar: friendInfo.avatar,
                    username: friendInfo.username,
                    msgid: data.msgid,
                    msgVersion: data.msgVersion,
                    msgType,
                });
            }

            if (msgType == 'friendText' || msgType == 'friendPic') {
                
                if (typeof sessionNotice[data.sId] == 'undefined') {
                    sessionNotice[data.sId] = 0;
                }
                
                ++sessionNotice[data.sId];
                
                // mini，接收新消息，展示红点。全屏，红点消失
                if (fullScreen == 1 && selected == 'msg' && activeFriend.oid) {
                    sessionNotice[activeFriend.oid] = 0;
                }

                this.cacheNoticeData(sessionNotice);

                this.addConversation(friendInfo);
            }

            activeSessionContent = this.getSessionContent(activeFriend.oid);          

            this.setState({
                activeSessionContent,
                sessionNotice
            });
        });

        im.on('resendMessageFail', (msgid)=>{
            let {activeFriend, activeSessionContent} = this.state;

            $.map(this.cacheSessionContent, (sessionContent, uid)=>{
                for (let i = sessionContent.length; i--;) {
                    let item = sessionContent[i];
                    
                    if (!item.isSelf) {
                        continue;
                    }

                    if (item.msgid == msgid) {
                        item.submiting = -1;
                        break;
                    }
                }
            })

            this.cacheIMData();

            activeSessionContent = this.getSessionContent(activeFriend.oid);
            
            this.setState({
                activeSessionContent
            });
        })
    }

    forcedOffline(){
        this.setState({
            showOfflineConfirm: 1
        }, function() {
            if (this.state.fullScreen == 1) {
                this.refs.offlineConfirm.showModal();
            }
        });
    }

    reconnect(){
        this.im.forcedOffline = 0;
        this.im.reconnect();
    }

    hideOfflineConfirm() {
        this.setState({
            showOfflineConfirm: 0
        });
    }

    addSessionContent(uid, item){
        if (!this.cacheSessionContent[uid]) {
            this.cacheSessionContent[uid] = [];
        }

        this.cacheSessionContent[uid].push(item)
        this.cacheIMData();
    }


    updateSessionContent(uid, list){
        if (!this.cacheSessionContent[uid]) {
            this.cacheSessionContent[uid] = [];
        }

        this.cacheSessionContent[uid] = list;
        this.cacheIMData();
    }

    getSessionContent(uid){
        return this.cacheSessionContent[uid] || [];
    }


    onKeyDown=(e)=>{
        let text = $(this.refs.text).val();

        if (text == '') {// 内容空
            switch (e.keyCode) {
                case 8:  // 'Backspace' key
                case 27: // 'Escape' key
                case 46: // 'Delete' key
                case 9:  // 'Tab' key
                case 13: // Enter key
                case 37: // 'Arrow left' key
                case 38: // 'Arrow up' key
                case 39: // 'Arrow right' key
                case 40: // 'Arrow down' key
                    e.preventDefault();
                    e.stopPropagation();
                    break;
            }

            return;

            notification.simple('发送空消息主播感受不到你的爱哒…');
        }

        if (e.shiftKey && e.which == 13) { //按ctrl+enter换行

        } else if ((e.keyCode || e.which) == 13 && !e.shiftKey) {  // 按Enter
            e.preventDefault();
            // 当前被强制下线
            if (this.im.forcedOffline == 1) {
                this.forcedOffline();
                return;
            }
            if (this.verifyFriendValid(this.state.activeFriend.oid)) {
                this.sendChat();    
            } else {
                this.doFriendApply();
            }
        }
    }

    doFriendApply() {
        notification.simple(lang.template('加个好友吧。聊嗨了才能拉近你们的距离哦！'));
    }

    // 验证当前用户是否是我的好友
    verifyFriendValid(uid) {
        if (uid == 10005) {
            return 1;
        } else {
            let friendInfo = this.getFriendById(uid);
            return friendInfo.uid ? 1 : 0;    
        }
    }   

    // 发送消息
    sendChat() {
        let text = $(this.refs.text).val();
        let activeSessionContent = this.state.activeSessionContent;
        let activedChatUid = this.state.activeFriend.oid;        
        let user = UP.Global.getUser();
        let msg;

        if(activedChatUid == 10005) {
            msg =  this.im.sendCustomServiceText(text);
        } else {
            msg = this.im.sendFriendText(activedChatUid, text);
        }
        
        text = sensitive.filter(text);

        $(this.refs.text).val('');

        activeSessionContent.push({
            isSelf: 1,
            oid: user.uid,
            username: '我',
            avatar: user.avatar,
            content: text,
            msgType: 'friendText',
            submiting: 1, // 数据上传中
            msgid: msg.msgid
        });

        this.updateSessionContent(activedChatUid, activeSessionContent);

        this.setState({
            activeSessionContent
        });

        UP.Global.DA.add({
            eventName: 'SendIMUserChat',
            action: 'click'
        });
    }

    talkTo(activeFriend) {
        let oid = activeFriend.oid;
        let activeSessionContent = this.getSessionContent(oid) || [];
        let activeFriendValid = this.verifyFriendValid(oid);
        let sessionNotice =  this.state.sessionNotice;

        sessionNotice[oid] = 0;
        this.cacheNoticeData(sessionNotice);

        this.setState({
            activeSessionContent,
            activeFriend,
            activeFriendValid,
            sessionNotice
        });
    }

    // 跟一个好友聊天
    talkToNewFriend(friend) {
        let oid = typeof friend.uid == 'object' ? Number(longToString(friend.uid)) : friend.uid;
        let activeSessionContent = this.getSessionContent(oid) || [];
        let activeFriendValid = this.verifyFriendValid(oid);
        let sessionNotice =  this.state.sessionNotice;
        
        let activeFriend = {
            type: 7,
            avatar: friend.avatar,
            name: friend.username,
            oid: oid
        }

        sessionNotice[oid] = 0;
        this.cacheNoticeData(sessionNotice);

        
        this.addConversation(friend);

        this.setState({
            activeFriend,
            activeSessionContent,
            activeFriendValid,
            sessionNotice,
            selected: 'msg',
            fullScreen: 1
        });
    }

    addConversation(friend) {
        let oid = typeof friend.uid == 'object' ? Number(longToString(friend.uid)) : friend.uid;
        let friendValid = this.verifyFriendValid(oid); 
        let conversations = this.state.conversations;

        let activeFriend = {
            type: 7,
            avatar: friend.avatar,
            name: friend.username,
            oid: oid
        }

        if (friendValid) {
            // 已经是好友
            // 若会话列表中没有，则添加会话列表记录
            let include = 0;

            for (var i = conversations.length ; i--;) {
                let item = conversations[i];

                if (item.oid == oid) {
                    include = 1;
                    break;
                }
            }

            if (!include ) {
                conversations[conversations.length] = activeFriend;
            }
        }

        this.setState({
            conversations
        })
    }

    onSwitchTab(selected) {

        this.setState({
            selected
        }); 

        if (selected == 'apply'){
            this.friendApply.clearUnhandledApplyCount();
            this.setState({
                applyNotice: 0
            });
        }
    }

    onFollowFriend(uid){
        loading.show();

        this.friendApply.follow({
            uid
        }, ()=>{
            loading.hide();
            // 同意好友申请
           this.updateApplyList();
        });
    }


    applyFriend(friendInfo) {

        this.setState({
            showApplyConfirm: 1
        }, function() {
            this.refs.applyConfirm.showModal();
        });
    }

    hideApplyConfirm(){
        this.setState({
            showApplyConfirm: 0
        })
    }
    sendApplyFriend(content){
        let uid = this.state.activeFriend.oid;

        loading.show();
        // TODO 二次确认框
        this.friendApply.follow({
            uid,
            content: content,
            addFriend: true
        }, ()=>{
            loading.hide();
            notification.simple(lang.template('申请发送成功'));
            // 同意好友申请
            this.updateApplyList();
        });  
    }

    updateApplyList(){
        let friendApplyList = this.friendApply.getApplyList();

        this.setState({
            friendApplyList
        });
    }

    deleteFriendById(uid) {
        this.friendList.deleteFriendById(uid);
        
        let friends = this.friendList.getFriendList();
        let { activeFriend, activeFriendValid } = this.state;
        
        if (uid == activeFriend.oid) {
            activeFriendValid = 0;
        }

        this.setState({
            friends,
            activeFriendValid
        });
    }

    addFriendById(uid) {
        this.friendList.addFriendById(uid).done(()=>{
            let friends = this.friendList.getFriendList();
            let { activeFriend, activeFriendValid } = this.state;
        
            if (uid == activeFriend.oid) {
                activeFriendValid = 1;
            }

            this.setState({
                friends,
                activeFriendValid
            });
        });
    }

    resendMessage(data) {
        if (this.im.forcedOffline == 1) {
            this.forcedOffline();
            return;
        }

        let activeSessionContent = this.state.activeSessionContent;
        let activedChatUid = this.state.activeFriend.oid;        
        let msg = this.im.sendFriendText(activedChatUid, data.content);
        
        data.submiting =  1;

        this.updateSessionContent(activedChatUid, activeSessionContent);

        this.setState({
            activeSessionContent
        });
    }

    toggleChatFullScreen(value) {
        let { sessionNotice, activeFriend } = this.state;

        if (value == 1) {
            this.cacheIMData();

            if (activeFriend.oid) {
                sessionNotice[activeFriend.oid] = 0;
                this.cacheNoticeData(sessionNotice);
            }

            UP.Global.DA.add({
                eventName: 'ShowIM',
                action: 'click'
            });
        }

        this.setState({
            fullScreen: value
        }, function(){
            // 全屏
            if (value == 1) {
                this.refs.offlineConfirm && this.refs.offlineConfirm.showModal();
            }
        });
    }

    onClickChatMsgAvatar(uid) {

    }
    goMomoRecharge = (e)=>{
        window.open('https://h5.upliveapp.com/ipay/index.html?env=&channel=codapay&lang=vi-VN&upcode=' + UP.Global.getUser().upliveCode);

    }

    renderConversationContent() {
        let { activeSessionContent, activeFriend , activeFriendValid} = this.state;
        let $userInfo;

        let $guideToAddFriend = (
            <div className="apply-tip">
                <div className="box">
                    <div className="msg">{lang.template('加个好友吧，聊嗨了才能拉近你们的距离哦！')}</div>
                    <span className="adding" onClick={this.applyFriend.bind(this)}>{lang.template('添加好友')}</span>
                </div>
            </div>
        );


        return (
            <div className="chat-content">
                <div className="chat-content-hd">
                    <div className="userinfo">
                       { activeFriend.oid == 10005 ? <OfficeItemView item={activeFriend}/> : <UserChatItemView item={activeFriend}/> }         
                    </div>
                </div>
                <div className="chat-content-bd">
                    { activeFriendValid == 0 ? $guideToAddFriend : null }
                    <div className="scroll-wrapper" ref="JContentWrap">
                        <ChatMsgListView list={activeSessionContent} resendMessage={this.resendMessage.bind(this)}/>
                    </div>
                </div>
                <div className="chat-content-ft">
                    <div className="chat-send">
                        <textarea ref="text" onKeyDown={this.onKeyDown.bind(this)} placeholder={lang.template('按下Enter发送内容')}></textarea>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { fullScreen, activeFriend, conversations, sessionNotice, applyNotice, activeFriendValid} = this.state;

        let noticeNum = 0;
            
        $.each(sessionNotice, (key, value)=>{
            noticeNum = noticeNum + value;
        })

        if (fullScreen == 0) {
            let sumNum = noticeNum + applyNotice;
                return (
                    <div className={this.props.name == 'take' ?"chat-mini-wrap chat-kefu" : "chat-mini-wrap chat-bottom-fixed"} id="J-IMChat" onClick={this.toggleChatFullScreen.bind(this, 1)}>
                        { sumNum > 0 ? (<i className="notice-num">{ sumNum > 99 ? '99+': sumNum }</i>) : null }
                    </div>
                );   
            
            
        } else {

            let $navs = this.props.navs.map((item, inx)=>{
                
                let selectedCls = item.option == this.state.selected ? ' selected' : '';
                let $badge;

                switch (item.option) {
                    case 'msg':
                        if (noticeNum > 99) {
                            $badge = <i className="notice-num">99+</i>
                        } else if (noticeNum > 0 && noticeNum <= 99){
                            $badge = <i className="notice-num">{noticeNum}</i>
                        }
                        break;
                    case 'apply':
                        if (applyNotice > 99) {
                            $badge = <i className="notice-num">99+</i>
                        } else if (applyNotice > 0 && applyNotice <= 99){
                            $badge = <i className="notice-num">{applyNotice}</i>
                        }
                        break;
                }


                return (
                    <div  
                        key={item.option} 
                        className={`chat-nav nav-${item.option}${selectedCls}`} 
                        onClick={this.onSwitchTab.bind(this,item.option)}
                    >
                        <h2 className="title">
                            { $badge }
                        </h2>
                    </div>
                );
            })
                    

            let $main = this.props.navs.map((item, inx)=>{
                
                let selectedCls = item.option == this.state.selected ? ' selected' : '';

                switch (item.option) {
                    case 'msg':
                        let $content;
                        
                        if (activeFriend.oid) {
                            $content = (
                                <div className="chat-content">
                                    { this.renderConversationContent() }
                                </div>
                            )
                        } else {
                            $content = (
                                <div className="chat-content">
                                    <div className="mini-tip">
                                        { lang.template('您还未选中或发起聊天，快去跟好友聊一聊吧') }
                                    </div>
                                </div>
                            )
                        }

                        return (
                            <div className={`panel${selectedCls}`} key={inx}>
                                <div className="chat-side">
                                    <div className="scroll-wrapper">
                                        <div className="scroller">
                                            <ConversationListView 
                                                selectedItem={activeFriend} 
                                                list={conversations}
                                                talkTo={this.talkTo.bind(this)}
                                                sessionNotice={sessionNotice}
                                            />
                                        </div>
                                    </div>
                                </div>
                                { $content }
                            </div>
                        );
                        break;
                    case 'friend':
                        return (
                            <div className={`panel${selectedCls}`} key={inx}>
                                <div className="scroll-wrapper">
                                    <div className="scroller">
                                        <FriendListView list={this.state.friends} talkTo={this.talkToNewFriend.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        );
                        break;
                    case 'apply':
                        return (
                            <div className={`panel${selectedCls}`} key={inx}>
                                <div className="scroll-wrapper">
                                    <div className="scroller">
                                        <FriendApplyListView list={this.state.friendApplyList} onFollowFriend={this.onFollowFriend.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        );
                        break;
                }
            })

            return (
                <div className="chat-wrap chat-bottom-fixed" id="J-IMChat">
                    <i className="close" onClick={this.toggleChatFullScreen.bind(this, 0)}></i>
                    <div className="chat-navs">{ $navs }</div>
                    <div className="chat-main">{ $main }</div>
                    { 
                        this.state.showApplyConfirm == 1 ? (
                            <ApplyConfirm  
                                ref="applyConfirm" 
                                onConfirm={this.sendApplyFriend.bind(this)} 
                                onHide={this.hideApplyConfirm.bind(this)}
                                myusername = {UP.Global.getUser().username}
                                friendusername = {activeFriend.name}
                            />
                        ) : null 
                    }
                    {
                        this.state.showOfflineConfirm == 1 ? (
                            <OfflineConfirm 
                                ref="offlineConfirm"
                                onConfirm={this.reconnect.bind(this)} 
                                onHide={this.hideOfflineConfirm.bind(this)}
                            />
                        ) : null
                    }
                </div>
            )
        }
        
    }
}


export default App;


// WEBPACK FOOTER //
// ./js/im/index.js